import { FormikProps } from 'formik';
import {
  BlogInput,
  BrandMissionInput,
  EmailInput,
  PersonaBlogInput,
  PersonaCallToActionInput,
  PersonaEmailInput,
  PersonaFeatureDescriptionInput,
  PersonaHeroHeaderInput,
  PersonaSocialInput,
  PersonaSubheaderInput,
  SocialInput,
  YoutubeVideoScriptInput,
  LinkedInCompanyBioInput,
  ValuePropInput,
} from '../../../../../types/FormTypes';
import { SliderInput } from '../../../../shared/inputs/SliderInput';

// import styles from './TemperatureSlider.module.css';

type TemperatureSliderProps<T> = {
  formikProps: FormikProps<T>;
  disabled: boolean;
};

export function TemperatureSlider<
  T extends
    BlogInput
   | PersonaBlogInput 
   | SocialInput 
   | EmailInput 
   | PersonaEmailInput 
   | PersonaSocialInput 
   | PersonaHeroHeaderInput 
   | PersonaSubheaderInput 
   | PersonaCallToActionInput 
   | PersonaFeatureDescriptionInput
   | BrandMissionInput
   | YoutubeVideoScriptInput
   | LinkedInCompanyBioInput 
   | ValuePropInput
>({ formikProps, disabled }: TemperatureSliderProps<T>) {
  return (
    <span aria-label="temperature-input">
      <SliderInput
        formikProps={formikProps}
        disabled={disabled}
        rangeLabels={['Less (Generic)', 'More (Creative)']}
        valueKey="temperature"
        label={
          <div>
            <h2>How much flavor do you want to add?</h2>
            <p>
              The less flavor, the more deterministic and repetitive the output
              becomes.
            </p>
          </div>
        }
      />
    </span>
  );
}
